export const RESTRICTED_PHONE_COUNTRIES: Set<string> = new Set([
  'PN',
  'GS',
  'UM',
  'HM',
  'TF',
  'AQ',
  'BV',
  'US',
  'CA-AB',
  'CA-BC',
  'CA-MB',
  'CA-ON',
  'CA-QC',
  'UA-43',
]);
